// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type InstallTasksPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type InstallTasksPageQuery = { __typename?: 'Query', items: Array<{ __typename?: 'Item', id: string, displayName: string }>, locations: Array<{ __typename?: 'Location', id: string, name: string }>, globalPlanTasks: { __typename?: 'GlobalPlanTasksPageResult', entities: Array<{ __typename?: 'GlobalPlanTask', id: string, name: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number } } };

export type ItemPlanTaskMappingsQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type ItemPlanTaskMappingsQuery = { __typename?: 'Query', itemPlanTaskMappingPage: { __typename?: 'ItemPlanTaskMappingPage', entities: Array<{ __typename?: 'ItemPlanTaskMapping', id: string, item: { __typename?: 'Item', id: string, displayName: string }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, task: { __typename?: 'GlobalPlanTask', id: string, name: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number } } };

export type SaveItemPlanTaskMappingMutationVariables = Types.Exact<{
  input: Types.SaveItemPlanTaskMappingInput;
}>;


export type SaveItemPlanTaskMappingMutation = { __typename?: 'Mutation', saveItemPlanTaskMapping: { __typename?: 'SaveItemPlanTaskMappingResult', itemPlanTaskMapping: { __typename?: 'ItemPlanTaskMapping', id: string, item: { __typename?: 'Item', id: string, displayName: string }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, task: { __typename?: 'GlobalPlanTask', id: string, name: string } } } };

export type DeleteItemPlanTaskMappingMutationVariables = Types.Exact<{
  input: Types.DeleteItemPlanTaskMappingInput;
}>;


export type DeleteItemPlanTaskMappingMutation = { __typename?: 'Mutation', deleteItemPlanTaskMapping: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type MaterialCatalog_ItemPlanTaskMappingFragment = { __typename?: 'ItemPlanTaskMapping', id: string, item: { __typename?: 'Item', id: string, displayName: string }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, task: { __typename?: 'GlobalPlanTask', id: string, name: string } };

export const MaterialCatalog_ItemPlanTaskMappingFragmentDoc = gql`
    fragment MaterialCatalog_ItemPlanTaskMapping on ItemPlanTaskMapping {
  id
  item {
    id
    displayName
  }
  location {
    id
    name
  }
  task {
    id
    name
  }
}
    `;
export const InstallTasksPageDocument = gql`
    query InstallTasksPage {
  items(filter: {version: 2}) {
    id
    displayName
  }
  locations(filter: {version: 2}) {
    id
    name
  }
  globalPlanTasks {
    entities {
      id
      name
    }
    pageInfo {
      hasNextPage
      totalCount
    }
  }
}
    `;

/**
 * __useInstallTasksPageQuery__
 *
 * To run a query within a React component, call `useInstallTasksPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstallTasksPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstallTasksPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useInstallTasksPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InstallTasksPageQuery, InstallTasksPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InstallTasksPageQuery, InstallTasksPageQueryVariables>(InstallTasksPageDocument, options);
      }
export function useInstallTasksPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InstallTasksPageQuery, InstallTasksPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InstallTasksPageQuery, InstallTasksPageQueryVariables>(InstallTasksPageDocument, options);
        }
// @ts-ignore
export function useInstallTasksPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InstallTasksPageQuery, InstallTasksPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InstallTasksPageQuery, InstallTasksPageQueryVariables>;
export function useInstallTasksPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InstallTasksPageQuery, InstallTasksPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InstallTasksPageQuery | undefined, InstallTasksPageQueryVariables>;
export function useInstallTasksPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InstallTasksPageQuery, InstallTasksPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InstallTasksPageQuery, InstallTasksPageQueryVariables>(InstallTasksPageDocument, options);
        }
export type InstallTasksPageQueryHookResult = ReturnType<typeof useInstallTasksPageQuery>;
export type InstallTasksPageLazyQueryHookResult = ReturnType<typeof useInstallTasksPageLazyQuery>;
export type InstallTasksPageSuspenseQueryHookResult = ReturnType<typeof useInstallTasksPageSuspenseQuery>;
export type InstallTasksPageQueryResult = ApolloReactCommon.QueryResult<InstallTasksPageQuery, InstallTasksPageQueryVariables>;
export const ItemPlanTaskMappingsDocument = gql`
    query ItemPlanTaskMappings($page: PageFilter) {
  itemPlanTaskMappingPage(page: $page) {
    entities {
      ...MaterialCatalog_ItemPlanTaskMapping
    }
    pageInfo {
      hasNextPage
      totalCount
    }
  }
}
    ${MaterialCatalog_ItemPlanTaskMappingFragmentDoc}`;

/**
 * __useItemPlanTaskMappingsQuery__
 *
 * To run a query within a React component, call `useItemPlanTaskMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemPlanTaskMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemPlanTaskMappingsQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useItemPlanTaskMappingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ItemPlanTaskMappingsQuery, ItemPlanTaskMappingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemPlanTaskMappingsQuery, ItemPlanTaskMappingsQueryVariables>(ItemPlanTaskMappingsDocument, options);
      }
export function useItemPlanTaskMappingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemPlanTaskMappingsQuery, ItemPlanTaskMappingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemPlanTaskMappingsQuery, ItemPlanTaskMappingsQueryVariables>(ItemPlanTaskMappingsDocument, options);
        }
// @ts-ignore
export function useItemPlanTaskMappingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ItemPlanTaskMappingsQuery, ItemPlanTaskMappingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemPlanTaskMappingsQuery, ItemPlanTaskMappingsQueryVariables>;
export function useItemPlanTaskMappingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemPlanTaskMappingsQuery, ItemPlanTaskMappingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemPlanTaskMappingsQuery | undefined, ItemPlanTaskMappingsQueryVariables>;
export function useItemPlanTaskMappingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemPlanTaskMappingsQuery, ItemPlanTaskMappingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ItemPlanTaskMappingsQuery, ItemPlanTaskMappingsQueryVariables>(ItemPlanTaskMappingsDocument, options);
        }
export type ItemPlanTaskMappingsQueryHookResult = ReturnType<typeof useItemPlanTaskMappingsQuery>;
export type ItemPlanTaskMappingsLazyQueryHookResult = ReturnType<typeof useItemPlanTaskMappingsLazyQuery>;
export type ItemPlanTaskMappingsSuspenseQueryHookResult = ReturnType<typeof useItemPlanTaskMappingsSuspenseQuery>;
export type ItemPlanTaskMappingsQueryResult = ApolloReactCommon.QueryResult<ItemPlanTaskMappingsQuery, ItemPlanTaskMappingsQueryVariables>;
export const SaveItemPlanTaskMappingDocument = gql`
    mutation SaveItemPlanTaskMapping($input: SaveItemPlanTaskMappingInput!) {
  saveItemPlanTaskMapping(input: $input) {
    itemPlanTaskMapping {
      ...MaterialCatalog_ItemPlanTaskMapping
    }
  }
}
    ${MaterialCatalog_ItemPlanTaskMappingFragmentDoc}`;

/**
 * __useSaveItemPlanTaskMappingMutation__
 *
 * To run a mutation, you first call `useSaveItemPlanTaskMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveItemPlanTaskMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveItemPlanTaskMappingMutation, { data, loading, error }] = useSaveItemPlanTaskMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveItemPlanTaskMappingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveItemPlanTaskMappingMutation, SaveItemPlanTaskMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveItemPlanTaskMappingMutation, SaveItemPlanTaskMappingMutationVariables>(SaveItemPlanTaskMappingDocument, options);
      }
export type SaveItemPlanTaskMappingMutationHookResult = ReturnType<typeof useSaveItemPlanTaskMappingMutation>;
export type SaveItemPlanTaskMappingMutationResult = ApolloReactCommon.MutationResult<SaveItemPlanTaskMappingMutation>;
export const DeleteItemPlanTaskMappingDocument = gql`
    mutation DeleteItemPlanTaskMapping($input: DeleteItemPlanTaskMappingInput!) {
  deleteItemPlanTaskMapping(input: $input) {
    emptyResult
  }
}
    `;

/**
 * __useDeleteItemPlanTaskMappingMutation__
 *
 * To run a mutation, you first call `useDeleteItemPlanTaskMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteItemPlanTaskMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteItemPlanTaskMappingMutation, { data, loading, error }] = useDeleteItemPlanTaskMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteItemPlanTaskMappingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteItemPlanTaskMappingMutation, DeleteItemPlanTaskMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteItemPlanTaskMappingMutation, DeleteItemPlanTaskMappingMutationVariables>(DeleteItemPlanTaskMappingDocument, options);
      }
export type DeleteItemPlanTaskMappingMutationHookResult = ReturnType<typeof useDeleteItemPlanTaskMappingMutation>;
export type DeleteItemPlanTaskMappingMutationResult = ApolloReactCommon.MutationResult<DeleteItemPlanTaskMappingMutation>;